import React from 'react';
import PageBanner from '../../components/PageBanner/PageBanner';
import './DisclaimerPage.css'; // Reusing the same CSS

const PrivacyPolicyPage: React.FC = () => {
    return (
        <div className="page-container">
            <PageBanner
                title="Privacy Policy"
                subtitle="How we handle your information"
                breadcrumbs={[
                    { label: 'Home', path: '/' },
                    { label: 'Privacy Policy', path: '/privacy-policy' }
                ]}
            />

            <div className="container section">
                <div className="legal-content">
                    <h3>Information Collection</h3>
                    <p>
                        We respect your privacy and are committed to protecting it. We may collect personal information such as your name, email address, and phone number only when you voluntarily submit it through our contact forms.
                    </p>

                    <h3>Use of Information</h3>
                    <p>
                        Any information provided by you is used solely for the purpose of communicating with you and responding to your inquiries. We do not sell, trade, or transfer your personal information to outside parties.
                    </p>

                    <h3>Cookies</h3>
                    <p>
                        This website may use cookies to enhance user experience. You can choose to set your web browser to refuse cookies or to alert you when cookies are being sent.
                    </p>

                    <h3>Changes to This Policy</h3>
                    <p>
                        We reserve the right to update this privacy policy at any time. We encourage users to check this page frequently for any changes.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicyPage;
